import { IconCall } from "../icon/variants/IconCall.js";
import { Flex } from "../mantine-passthroughs/index.js";
import { Anchor } from "../anchor/Anchor.js";
import { Body1 } from "../typography/Body1.js";
import { formatPhoneNumber } from "./phone-number.formatter.js";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/phone-number/PhoneNumber.tsx
const PhoneNumber = ({ phone, showIcon = true, actionable = true, "data-testid": testId }) => {
	const iconColor = actionable ? "primary" : "secondary";
	if (!phone) return null;
	return /* @__PURE__ */ jsx(Anchor, {
		href: actionable ? `tel:${phone}` : void 0,
		textDecoration: "none",
		"data-testid": testId,
		children: /* @__PURE__ */ jsxs(Flex, {
			align: "center",
			gap: "xxs",
			children: [showIcon && /* @__PURE__ */ jsx(IconCall, { color: iconColor }), /* @__PURE__ */ jsx(Body1, { children: formatPhoneNumber(phone) })]
		})
	});
};

//#endregion
export { PhoneNumber };